<template>
  <div class="app-dropdown">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'AppDropdown',

  data() {
    return {
      dropdownMenu: undefined,
    }
  },

  mounted() {
    const button = this.$slots.default.find(
      node => node.componentOptions.tag === 'app-button',
    )?.componentInstance

    if (button) button.$on('click', this.onButtonClick)
  },

  methods: {
    open() {
      this.dropdownMenu.open()
    },

    close() {
      this.dropdownMenu.close()
    },

    onButtonClick() {
      this.open()
    },
  },
}
</script>

<style lang="scss" scoped>
.app-dropdown {
  position: relative;

  > .app-dropdown-menu {
    position: absolute;
    top: 100%;
    right: 0;
    z-index: 1;
    height: 0;
    overflow-y: hidden;
    // display: none;

    &.active {
      height: auto;
    }
  }
}
</style>
